import React from "react";
import classNames from "classnames";
import {
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Collapse,
} from "@material-ui/core";
import IconExpandLess from "@material-ui/icons/ExpandLess";
import IconExpandMore from "@material-ui/icons/ExpandMore";
import AssignmentIcon from "@material-ui/icons/Assignment";
import exerciseConstants from "constants/Exercises/exerciseConstants";
import { EXERCISE_MODULES } from "./exerciseModule";

/**
 * Componente de Menu Retrátil para seleção de submódulos de exercícios (Gramática e Máquinas).
 * Integrado à Sidebar do sistema LFAWEB.
 * * @author Willian
 * @param {Object} props Propriedades do componente.
 * @param {Object} props.classes Classes de estilo vindas do Material-UI/Theme.
 * @param {string} props.language Idioma atual da interface ('pt' ou 'en').
 * @param {Object} props.constants Constantes gerais de rotas e navegação.
 * @param {Object} props.props Propriedades adicionais (como rtlActive).
 * @param {boolean} props.isOpen Estado que indica se o submenu está aberto.
 * @param {Function} props.toggleMenu Função para alternar a abertura do menu.
 * @param {Function} props.onOpenSelector Função para abrir o seletor do tipo de exercício.
 * @returns {JSX.Element} O menu de exercícios renderizado.
 */
export default function ExerciseMenu({
  classes,
  language,
  constants,
  props,
  isOpen,
  toggleMenu,
  onOpenSelector,
}) {
  const modules = Object.values(EXERCISE_MODULES);

  const menuLabels = exerciseConstants.title;

  // Busca segura das labels de navegação
  let buttonRouter = {};
  if (constants && constants.buttonRouter) {
    buttonRouter = constants.buttonRouter;
  }

  let exercisesMainLabel = {};
  if (buttonRouter.exercises) {
    exercisesMainLabel = buttonRouter.exercises;
  }

  // Definição do ícone de expansão sem operador ternário direto no JSX
  let expandIcon = <IconExpandMore />;
  if (isOpen) {
    expandIcon = <IconExpandLess />;
  }

  return (
    <>
      <ListItem
        button
        className={classNames(classes.itemText, classes.button, {
          [classes.itemTextRTL]: props.rtlActive,
        })}
        onClick={toggleMenu}
      >
        <ListItemIcon>
          <div
            style={{
              width: 50,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <AssignmentIcon style={{ color: "#252536" }} />
          </div>
        </ListItemIcon>

        <ListItemText primary={exercisesMainLabel[language]} />

        {/* Ícone dinâmico definido logicamente fora do return */}
        {expandIcon}
      </ListItem>

      <Collapse in={isOpen} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <div className={classes.wrapperList}>
            {modules.map((mod) => (
              <ListItem
                key={mod.key}
                button
                className={classNames(classes.itemText, classes.button)}
                onClick={() => onOpenSelector(mod.key)}
              >
                <ListItemText
                  inset
                  primary={menuLabels[mod.labelKey][language]}
                />
              </ListItem>
            ))}
          </div>
        </List>
      </Collapse>
    </>
  );
}
